module.exports = __webpack_public_path__ + "img/flag-usa.a46ac246.svg";